<template>
  <div class="wap-page">
    <div class="notice-content">
      <div class="notice-title">授权成功</div>
      <div class="notice-img">
        <img src="@/assets/img/tc-mobile.png" />
      </div>
      <div class="notice-desc">授权成功，稍后请登录移动云盘APP查看照片！</div>
      <div class="notice-btn" @click="goBack">
        <el-button
          type="primary"
          color="#0463ee"
          @click.stop="goBack"
          v-loading.fullscreen.lock="fullscreenLoading"
        >
          返回订单列表
        </el-button>
      </div>
      <!-- <div class="notice-btn"  style="padding-top:20px">
                <el-button type="primary" color="#0463ee" @click.stop="goBackLink">
                    查看照片
                </el-button>
            </div>
            <div class="qrcode">
                <img :src="imgBase64" />
                <div class="p">长按识别</div>
            </div> -->
    </div>
  </div>
</template>
<script>
import { remoteLoadScript } from "@/utils/remoteLoad";
import { getNotice } from "@/api/yunpan";
import jrQrcode from "jr-qrcode";

export default {
  name: "noticePage",
  data() {
    return {
      _obj: {},
      fullscreenLoading: true,
      imgBase64: "",
    };
  },
  methods: {
    goBack() {
      wx.miniProgram.navigateBack();
      wx.miniProgram.postMessage({ data: this._obj });
    },
    goBackLink() {
      window.location.href =
        "https://m.mcloud.139.com/portal/clientDL/index.html?v=mCloud_89844222069";
    },
  },

  async mounted() {
    await remoteLoadScript("https://res.wx.qq.com/open/js/jweixin-1.6.2.js");
    this.imgBase64 = jrQrcode.getQrBase64(
      "https://m.mcloud.139.com/portal/clientDL/index.html?v=mCloud_89844222069",
      {
        padding: 0, // 二维码四边空白（默认为10px）
        width: 500, // 二维码图片宽度（默认为256px）
        height: 500, // 二维码图片高度（默认为256px）
        correctLevel: QRErrorCorrectLevel.H, // 二维码容错level（默认为高）
        reverse: false, // 反色二维码，二维码颜色为上层容器的背景颜色
        background: "#ffffff", // 二维码背景颜色（默认白色）
        foreground: "#000000", // 二维码颜色（默认黑色）
      }
    );
    const { uuid, studentId, orderId } = this.$route.query;
    if (uuid == undefined) {
      this.fullscreenLoading = false;
      return false;
    }
    try {
      const params = { uuid, studentId, orderId };
      console.debug(params);
      const res = await getNotice(params);
      this.fullscreenLoading = false;
      if (res.code == 0) {
        const _obj = {
          uuid: uuid,
          studentId: studentId,
          orderId: orderId,
        };
        this._obj = _obj;
      } else {
        alert("登录失败");
        this.fullscreenLoading = false;
        this.goBack();
      }
    } catch (e) {
      alert("参数错误");
      this.fullscreenLoading = false;
      this.goBack();
    }
  },
};
</script>
<style scoped>
body {
  min-width: auto !important;
}

.wap-page {
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  min-height: 100vh;
  overflow: hidden;
}

.notice-content {
  text-align: center;
  padding-top: 15%;
}

.notice-title {
  font-size: 32px;
  color: #333;
}

.notice-img {
  width: 60%;
  margin: 0 auto;
  padding-top: 30px;
}

.notice-desc {
  font-size: 16px;
  color: #666;
  width: 60%;
  margin: 0 auto;
  padding-top: 50px;
}

.notice-img img {
  max-width: 100%;
}

.notice-btn {
  width: 80%;
  margin: 0 auto;
  padding-top: 30px;
}

.notice-btn .el-button {
  width: 100%;
  border-color: #0463ee;
  background-color: #0463ee;
}
.qrcode {
  padding: 25px 0;
}
.qrcode img {
  width: 120px;
  height: 120px;
}
.qrcode .p {
  color: #999;
}
</style>
